import { CoatingBodySize, CoatingPolishOption } from '@/types/api/coatingApi';

export const coatingSteps = {
  PRE_SELECTION: 1,
  REGISTATION: 2,
  ADDITIONAL_INFO: 3,
  REVIEW: 4,
} as const;

export const coatingServiceType = 'coating' as const;

export const coatingBodySizes = {
  SEDAN: 1,
  SUV_MPV: 2,
} as const;

export const coatingPolishOptions = {
  NONE: 0,
  MIN_60: 1,
  MIN_150: 2,
} as const;

export const coatingBodySizeOptions: {
  label: string;
  value: CoatingBodySize;
}[] = [
  {
    label: 'Sedan（セダン・コンパクト等）',
    value: coatingBodySizes.SEDAN,
  },
  {
    label: 'SUV / MPV（SUV・ミニバン等）',
    value: coatingBodySizes.SUV_MPV,
  },
];

export const coatingPolishOptionOptions: {
  label: string;
  value: CoatingPolishOption;
}[] = [
  {
    label: '磨き無し（新車向け）',
    value: coatingPolishOptions.NONE,
  },
  {
    label: '60分磨き（既販車3年未満）',
    value: coatingPolishOptions.MIN_60,
  },
  {
    label: '150分磨き（既販車3年以上）',
    value: coatingPolishOptions.MIN_150,
  },
];

export const coatingMarginTypes = {
  NONE: 3,
  YES: 1,
  NARROW_GAP: 2,
} as const;

export const coatingScratchedChecks = {
  AVAILABLE: 1,
  NOT_AVAILABLE: 2,
} as const;

export const coatingSecuritySystems = {
  YES: 1,
  NO: 2,
  UNKNOWN: 9,
} as const;

export const coatingCancellationFrom = {
  USER: 1,
  OPERATOR: 2,
} as const;

export const coatingCancellationType = {
  ANOTHER_APPOINTMENT: 4,
  NO_NEED: 5,
  OTHER: 7,
} as const;

export const coatingCancellationTypeOptions = [
  {
    value: coatingCancellationType.ANOTHER_APPOINTMENT,
    text: '都合が悪くなってしまった',
    detail: '別の予定が入った',
  },
  {
    value: coatingCancellationType.NO_NEED,
    text: 'コーティングをしないことにした',
    detail: 'サービスが不要になった',
  },
  {
    value: coatingCancellationType.OTHER,
    text: 'その他',
    detail: '',
  },
];

/** 予約締切日数（今日から何日後以降を選択可能とするか） */
export const COATING_MIN_DAYS_AHEAD = 10;

/**
 * ウィンドウコーティング系オプション名キーワード
 * このキーワードを含むオプションは排他選択（1つだけ選択可能）
 */
export const COATING_WINDOW_OPTION_KEYWORDS = ['ウィンドウコーティング'];

/**
 * 磨き必須メーカー
 * 該当メーカーの車両はBRILA RED LINE固定 + 磨き無し選択不可
 */
export const COATING_POLISH_REQUIRED_MAKERS = [
  'ニッサン',
  '日産',
  'NISSAN',
  'ホンダ',
  'HONDA',
];

/**
 * RED LINE のコーティングアイテムコード
 */
export const COATING_RED_LINE_CODE = '23';
